import script from "./SetupDrawer.vue?vue&type=script&setup=true&lang=js"
export * from "./SetupDrawer.vue?vue&type=script&setup=true&lang=js"

import "./SetupDrawer.vue?vue&type=style&index=0&id=27313548&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.38_vue@3.5.38_webpack@5.107.2_postcss@8.5.15_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27313548"]])

export default __exports__

/* vue-cli-plugin-import-components */

import ImportWizardModal from "@/components/neue/ImportWizardModal.vue";
import SetupAssistantStep from "@/components/setup/steps/SetupAssistantStep.vue";
import SetupCustomersStep from "@/components/setup/steps/SetupCustomersStep.vue";
import SetupPaymentsStep from "@/components/setup/steps/SetupPaymentsStep.vue";
import SetupReviewPanel from "@/components/setup/SetupReviewPanel.vue";
import SetupStep from "@/components/setup/SetupStep.vue";
import SetupStoreDetailsStep from "@/components/setup/steps/SetupStoreDetailsStep.vue";
script.components = Object.assign({}, { ImportWizardModal, SetupAssistantStep, SetupCustomersStep, SetupPaymentsStep, SetupReviewPanel, SetupStep, SetupStoreDetailsStep }, script.components);if ('__vccOpts' in script) { script.__o = script.__o || {}; script.__o.components = Object.assign({}, { ImportWizardModal, SetupAssistantStep, SetupCustomersStep, SetupPaymentsStep, SetupReviewPanel, SetupStep, SetupStoreDetailsStep }, script.__o.components);}